export const FINANCIAL_CARRIERS = ['CityMail', 'Earlybird', 'PostNord', 'Deutsche Post'] as const
export type FinancialCarrier = (typeof FINANCIAL_CARRIERS)[number]

export const FINANCIAL_FILE_MAX_BYTES = 20 * 1024 * 1024
export const FINANCIAL_FILE_MAX_EXPANDED_BYTES = 160 * 1024 * 1024
export const FINANCIAL_FILE_MAX_ROWS = 100000
export const FINANCIAL_FILE_MAX_COLUMNS = 100
export const FINANCIAL_PREVIEW_ROWS = 10
export const FINANCIAL_PAGE_SIZE = 25
// Amounts are compared at 1/100 öre. XLSX stores binary doubles such as 21.655000000000001.
export const FINANCIAL_COMPARE_DECIMALS = 4

export const FINANCIAL_ACTIVE_CARRIERS = FINANCIAL_CARRIERS
export type FinancialActiveCarrier = (typeof FINANCIAL_ACTIVE_CARRIERS)[number]
export const FINANCIAL_CARRIER_HANDLES = { CityMail: 'citymail', Earlybird: 'earlybird', PostNord: 'postnord', 'Deutsche Post': 'deutschepost' } as const

export const FINANCIAL_DEUTSCHE_POST_HEADERS = [
  'Invoice Number', 'Shipment ID', 'Product Code', 'Product Description', 'Service Date',
  'Net Price', 'Currency', 'Weight', 'Weight Unit',
]
export const FINANCIAL_DEUTSCHE_POST_LEGACY_ERROR =
  'This is a Deutsche Post Level 2/Level 3 report, not the supported shipment invoice. It mixes summary and detail rows and may contain references outside PacSort. Upload the shipment invoice with Shipment ID and Net Price.'

// Weight columns per supplied template. Units were verified against the booked PacSort weights of the
// supplied September invoices: CityMail repeats the booked weight, PostNord and Earlybird report measurements.
export const FINANCIAL_WEIGHT_SOURCES = {
  CityMail: { column: 'Vikt', unit: 'kg', measured: false },
  Earlybird: { column: 'Weight', unit: 'kg', measured: true },
  PostNord: { column: 'Gross weight', unit: 'g', measured: true },
  'Deutsche Post': { column: 'Weight', unit: 'kg', measured: true },
} as const

// Product names on separate invoice rows that are fees for an existing shipment, not its delivery.
export const FINANCIAL_ADDITIONAL_PRODUCTS: Partial<Record<FinancialActiveCarrier, RegExp>> = {
  CityMail: /ÖMÅTT|UTHÄMTAT/i,
  PostNord: /surcharge|special handling|incorrect label/i,
  'Deutsche Post': /surcharge/i,
}

export const FINANCIAL_CURRENCIES = ['SEK', 'EUR', 'DKK', 'NOK', 'GBP', 'USD'] as const

// PacSort's booked customer prices (actualPrice) have no currency field and are SEK, as in PacSort's finance export.
export const FINANCIAL_BOOKED_CURRENCY = 'SEK'
// Concurrent customer-margin requests, one per company.
export const FINANCIAL_MARGIN_REQUESTS = 4
// Demo assumption until 21grams sets the date: shipments booked before this were invoiced in advance.
export const FINANCIAL_ARREARS_FROM = '2026-05-01'
